import { SVGProps } from 'react'

export const QuestionMarkCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_2966_1128)">
      <path
        d="M7.57484 7.49996C7.77076 6.94302 8.15746 6.47338 8.66647 6.17424C9.17547 5.87509 9.77392 5.76574 10.3558 5.86555C10.9377 5.96536 11.4655 6.2679 11.8457 6.71957C12.226 7.17124 12.4341 7.74289 12.4332 8.33329C12.4332 9.99996 9.93317 10.8333 9.93317 10.8333M9.99984 14.1666H10.0082M18.3332 9.99996C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 9.99996C1.6665 5.39759 5.39746 1.66663 9.99984 1.66663C14.6022 1.66663 18.3332 5.39759 18.3332 9.99996Z"
        stroke="#364359"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2966_1128">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
